/// <reference types="node" />
const _default_1: string | false | undefined =
	typeof process !== 'undefined' &&
	process !== null &&
	process.env?.['ANALYTICS_NEXT_MODERN_CONTEXT'];
export default _default_1;
